<template>
    <tr>
        <td>
            {{ appraisal.point }}
        </td>
        <td>
            {{ appraisal.reason }}
        </td>
        <td>
            {{ appraisal.registrant.name }}
        </td>
        <td>
            <router-link
            :to="{name: 'edit_appraisal', params: {identity: appraisal.identity}}"
            class="ui basic primary button"
            >
                {{ $t('ui.general.edit') }}
            </router-link>
            <button class="ui basic negative button" @click.prevent="delete_appraisal()">
                {{ $t('ui.general.delete') }}
            </button>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        appraisal: Object
    },
    data: function () {
        return {
            is_processing: false,
        }
    },
    computed: {
    },
    created: function() {
    },
    mounted: function() {
    },
    watch: {
    },
    methods: {
        delete_appraisal: function() {
            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                var that = this;
                that.is_processing = true;
                var url = new RestUrl(that.$store.state.provider.routes.api_v1_provider_appraisal_delete).parse(
                    {
                        "appraisal_identity": that.appraisal.identity,
                    },
                    ""
                );

                axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(function (response) {
                    if (response.data.status == "success") {
                        that.$parent.init();
                        // that.$noty.success("考績刪除成功");
                        that.$noty.success(
                            that.$t('ui.notifications.success.delete__name', {
                                name: that.$t('models.appraisals')
                            })
                        );
                    } else {
                        that.$noty.error("考績刪除失敗");
                    }
                })
                .catch(function (error) {
                    if (!error.response) {
                        // Network Error
                        that.$noty.error(
                            that.$t('ui.general.network_abnormality')+": "+
                            that.$t('ui.general.server_offline')
                        );
                    } else {
                        that.$noty.error(that.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data);
                    }
                });
                that.is_processing = false;
            }
        },
    },
    components: {
    }
}
</script>
